export const isIphone = () =>
  !!navigator.platform
    ? navigator.platform.match(/iPad|iPhone|iPod/) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    : navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
